<template>
    <v-flex>
      <v-list>
        <v-list-tile
          class="py-2 file-item"
          v-for="(fileItem, index) in filesList"
          :key="index">

          <object height="80" style="max-width: 60%" :data="fileItem"></object>

          <v-list-tile-content>
            <v-btn @click="removeFile(index)"
                   color="accent"
                   flat>
              Remove
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <input type="file" style="" ref="inputElRef"
             :multiple="multiple"
             hidden @change="processFiles($event)"/>

      <v-btn @click="openFileSelector('inputElRef')"
             v-if="!loading"
             block :flat="hasFiles"
             :class="!hasFiles ? btnClass : null"
             :loading="loading"
             :disabled="disabled">
        <template v-if="filesList.length">
          Add More
        </template>
        <template v-else>
          Select Photo(s)
        </template>
      </v-btn>

      <v-progress-linear v-if="uploadingProgress !== null"
                         class="mt-0 pt-0"
                         v-model="uploadingProgress">
      </v-progress-linear>

      <v-btn @click="upload()"
             v-if="hasFiles"
             :class="btnClass"
             block
             :loading="loading"
             :disabled="disabled">
        Continue
      </v-btn>
    </v-flex>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FilesUploadBtn',
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    btnClass: {
      type: String,
      default() {
        return 'primary mx-0';
      },
    },
    uploadingProgress: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      loadingBtn: false,
      filesList: [],
    };
  },
  computed: {
    hasFiles() {
      return !!this.filesList.length;
    },
    loading() {
      return this.uploadingProgress !== null || this.loadingBtn;
    },
  },
  methods: {
    removeFile(index) {
      this.filesList.splice(index, 1);
      this.$emit('fileCount', this.filesList.length);
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async processFiles(event) {
      this.loadingBtn = true;
      const getBase64ApiCalls = [];
      const files = _.get(event, 'target.files', null);

      if (files) {
        Array.prototype.forEach.call(files, (file) => {
          const base64FilePromise = this.getBase64(file);
          getBase64ApiCalls.push(base64FilePromise);
        });
      }

      const billOfLadingBase64s = await Promise.all(getBase64ApiCalls);
      this.$set(this, 'filesList', this.filesList.concat(billOfLadingBase64s));
      this.loadingBtn = false;
      this.$emit('fileCount', this.filesList.length);
    },
    upload() {
      this.$emit('upload', this.filesList);
    },
    openFileSelector(refId) {
      this.$refs[refId].click();
    },
  },
};
</script>

<style scoped>
  .file-item {
    height: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FilesUploadBtn.vue